import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequestWithApiKey } from "../../services/API";

const APP_INFO = "fetchAppInfo";

export const fetchAppInfo = createAsyncThunk(
  APP_INFO,
  async ({ language }, { rejectWithValue }) => {
    try {
      // Use API key for app version requests (public endpoint)
      let appVersionResult = await getRequestWithApiKey(language, "appVersion");
      return appVersionResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);
